import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-custom-warning',
	templateUrl: './custom-warning.component.html',
	styleUrls: ['./custom-warning.component.scss']
})
export class CustomWarningComponent {
	@Input() customWarning?: CustomWarning = { shouldRender: false, message: '' };
}

export interface CustomWarning {
	shouldRender: boolean;
	message: string;
}
